//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { industry } from '@/utils/lecturer';

export default {
  name: 'CourseDetailedItem',
  props: {
    item: { type: Object, default: () => {} },
    isFavorites: { type: Boolean, default: false },
    isApplication: { type: Boolean, default: false },
  },
  methods: {
    getIndustry(item, key) {
      return industry[item][key];
    },
    onApply(courseId) {
      this.$api('addCourseJoin', { courseId }).then(data => {
        this.$message.success('申請成功!');
      });
    },
    onRemoveCollect(courseId) {
      this.$api('removeCourseCollect', { courseId }).then(data => {
        this.$message.success('取消收藏成功!');
        this.$emit('update');
      });
    },
    onRemoveApply(courseId) {
      this.$api('removeCourseJoin', { courseId }).then(data => {
        this.$message.success('取消申請成功!');
        this.$emit('update');
      });
    },
  },
};
